import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import DoneOutlinedIcon from "@mui/icons-material/DoneOutlined";
import TextsmsOutlinedIcon from "@mui/icons-material/TextsmsOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { Input } from "@mui/material";
import { useContext, useEffect, useRef, useState } from "react";
import api from "../../../BrandOnBoarding/api";
import Modal from "../../../Component/Modal/Modal";
import MUIIconButton from "../../../Component/UI/MUIIconButton/MUIIconButton";
import { AuthContext } from "../../../context/auth-context";
import { LLM_OPTIONS } from "../../../utils/constant";
import { DiscoveryContext } from "../discovery-context";
import classes from "./HistoryItem.module.css";
import { toast } from "react-toastify";


export default function HistoryItem({ item, onDelete, onUpdate, setCancelTransaction = () => { },startPolling=()=>{} }) {
  const [name, setName] = useState(item?.brand);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [isError, setIsError] = useState(false);
  console.log("itemData", item, name)

  const discoveryCtx = useContext(DiscoveryContext);
  const transactionIdRef = useRef();
  const { user } = useContext(AuthContext);
  const webSocketBaseURL = process.env.REACT_APP_ORCHESTRATOR_BASE_URL;

  function deleteHistoryItemHandler() {
    setCancelTransaction(true);
    setShowDeleteDialog(false);
    onDelete(item.transactionId);
  }

  const statusColors = {
    COMPLETED: "green",
    RETRY: "red",
    DEFAULT: "#FCD34D",
  };

  function handleDoneEditing() {
    if (isError) {
      return;
    }
    setIsError(false);
    setIsEditing(false);
    if (
      item.name.toString().toLowerCase().trim() ==
      name.toString().toLowerCase().trim()
    ) {
      return;
    }
    onUpdate(item.id, name);
  }

  function handleInputChange(e) {
    const enteredInput = e.target.value;
    if (enteredInput.trim().length === 0) {
      setIsError(true);
    } else {
      setIsError(false);
    }
    setName(e.target.value);
  }

  const handleKeyDown = (event) => {
    if (event.key === "Escape") {
      setName(item?.name || item.entity);
      setIsError(false);
      setIsEditing(false);
    }
  };

  useEffect(() => {
    if (discoveryCtx.state.transactionId) {
      transactionIdRef.current = discoveryCtx.state.transactionId;
    }
  }, [discoveryCtx.state.transactionId]);

  let currentBrandSnippets = [];
  let currentBrandThemes = [];
    const coreAttributeMap = {};
  const handleSocketData = (socketResponse, transaction) => {
    if (!socketResponse || typeof socketResponse !== 'object') {
      console.error("Invalid socket response:", socketResponse);
      return;
    }

    let { type, request, response, category, llm, status } = socketResponse;
    let transactionId = transaction?.transactionId;

    if (!type || !request) {
      console.error("Incomplete socket response:", response);
      return;
    }
    if (status !== 'COMPLETED') {
      return false
    }
    const currentContextTxnId = transactionIdRef.current;
    if (transactionId !== currentContextTxnId) return;
    console.log("DiscoveryHistoryResponse", socketResponse)
    switch (type) {
      case "rank":
        if (!response) return console.warn("Missing response for rank");
        response = { ...response, request_id: socketResponse.id };
        const sources = [...Object.keys(response?.sources?.rank || {})];
        discoveryCtx.updateSources(sources);
        discoveryCtx.updateRankScores(response);
        break;

      case "sentiment":
        if (!response || !transaction) return console.warn("Missing response/Transaction for sentiment");

        const entity = { ...response?.data }?.[0];
        const brandRes = response?.error
          ? { error: "something went wrong" }
          : {
            name: entity?.name || "Unknown",
            favorability: entity?.score ?? 0,
            extras: response.extras,
          };

        let index = -1;
        try {
          transaction.competitor?.[request.category]?.forEach((item, idx) => {
            if (item.name?.toLowerCase() == entity?.name?.toLowerCase()) {
              index = idx;
            }
          }
          );
          if (transaction.brand === entity?.name) index = -1;
        } catch (err) {
          console.warn("Error calculating sentiment index:", err);
        }
        const sentimentSources = [
          ...Object.keys(response?.sources?.sentiment || {}),
        ];
        console.log('updating brand score ', transaction.brand, entity?.name, transaction.competitor?.[request.category], index)
        discoveryCtx.updateBrandScores({
          data: brandRes,
          index: index + 1
        });
        discoveryCtx.updateSources(sentimentSources);
        break;

      case "signalStrength":
        if (!response) return console.warn("Missing response for signalStrength");

        const negativeAttributes = response?.aggregatedNegatives || [];
        const positiveAttributes = response?.aggregatedPositives || [];
        const sourcesPosNeg = [
          ...(response?.aggregatedPositiveSources || []),
          ...(response?.aggregatedNegativeSources || []),
        ];

        discoveryCtx.updatePositiveNegativeAttributes({
          name : socketResponse.brand,
          positives: positiveAttributes.slice(0, 10),
          negatives: negativeAttributes.slice(0, 10),
        });

        discoveryCtx.updateSources(sourcesPosNeg);
        break;

      case "categoryDimension":
        if (!response) return console.warn("Missing response for categoryDimension");
        discoveryCtx.updateCategoryDimensions({
          data: response?.data || [],
          summary: response?.summary || "",
        });

        const sourcesCategoryDim = [
          ...Object.keys(response?.sources?.category || {}),
          ...Object.keys(response?.sources?.dimension || {}),
        ];

        discoveryCtx.updateSources(sourcesCategoryDim);
        break;

      case "taxonomy":
        if (!response) return console.warn("Missing response for taxonomy");
        discoveryCtx.updatedTaxonomies(response.data);
        break;

      case "core-attribute":
        if (!response || !category || !llm) return console.warn("Missing data for core-attribute");

        const key = `${llm}__${category}`;

        if (!coreAttributeMap[key]) {
          coreAttributeMap[key] = [];
        }

        coreAttributeMap[key].push(response);

        if (coreAttributeMap[key].length === 4) {
          const group = coreAttributeMap[key];
          let coreAttributeSummary = "";
          const products = [];
          const sources = [];

          const category_averages = group[0]?.category_averages;

          let competitors = transaction?.competitor?.[category].map((item) => item.name);
          let brand = transaction?.brand;
          if (competitors) {
            competitors.unshift(brand);
          } else {
            competitors = [];
          }

          for (const res of group) {
            if (!res?.error && Array.isArray(res?.products)) {
              coreAttributeSummary += res.products?.[0]?.summary || "";
              coreAttributeSummary += "\n\n";
              products.push(res.products?.[0]);
              sources.push(
                ...Object.keys(res?.sources?.category || {}),
                ...Object.keys(res?.sources?.product || {})
              );
            }
          }

          let sortedProducts = [];

          for (const company of competitors) {
            const normalizedCompany = company.toLowerCase().replace(/\s+/g, "");
            for (const product of products) {
              const normalizedProductName = product.name.toLowerCase().replace(/\s+/g, "");
              if (normalizedProductName === normalizedCompany) {
                  sortedProducts.push(product);
                break;
              }
            }
          }

          discoveryCtx.updateCoreAttributes({
            category_averages,
            products: sortedProducts,
            summary: coreAttributeSummary,
          });

          discoveryCtx.updateSources(sources);

          delete coreAttributeMap[key];
        }
        break;

      case "description":
        if (!response?.data) return console.warn("Missing response.data for description");
        discoveryCtx.updateBrandDescription(response.data);
        break;

      case "theme":
      case "snippet": {
        const isTheme = type === "theme";
        const dataSnippet = response?.data?.data;

        if (!Array.isArray(dataSnippet)) {
          console.warn(`${type} response is not a valid array:`, dataSnippet);
          return;
        }

        // const llm = transaction?.primaryLLM;
        console.log("llmdata", llm, category)
        if (!llm || !category) {
          console.warn("Missing llm/category for", type);
          return;
        }

        const targetStore = isTheme ? currentBrandSnippets : currentBrandThemes;
        const contextMethod = isTheme
          ? discoveryCtx.updateBrandSnippets
          : discoveryCtx.updatedBrandThemes;
        if (!targetStore) targetStore = {};
        if (!targetStore) targetStore = [];

        targetStore.push(dataSnippet)
        contextMethod({
          res: targetStore
        });

        break;
      }

      default:
        console.warn(`Unhandled socket data type: ${type}`);
    }
  };

  const getTransactionData = async (transactionRecord) => {
    let transactionId = transactionRecord.transactionId;
    discoveryCtx.resetState();
    discoveryCtx.updateTransactionId(transactionId)
    console.log("transactionRecord", transactionRecord)
    discoveryCtx.updateEntity(transactionRecord.brand);
    let competitors = transactionRecord.competitor[transactionRecord.category];
    competitors = [{ name: transactionRecord.brand, domain: transactionRecord.brandDomainName, variants: [], display_name: transactionRecord.brand }, ...competitors];
    discoveryCtx.updatedCompetitors(competitors);
    discoveryCtx.updateMarket(transactionRecord.market.join(','));
    discoveryCtx.updateTransactionStatus(transactionRecord.status);
    discoveryCtx.updateCategory(transactionRecord.category[0]);
    discoveryCtx.updateLLM(transactionRecord.llm[0]);
    // fix domain issue later
    discoveryCtx.updateName(`${transactionRecord.brand} Brand Overview`);

    discoveryCtx.updateId(transactionId);
    discoveryCtx.updatedLaunched(true);
    if (transactionRecord.status === "COMPLETED") {
      discoveryCtx.updateLoading(false);
    } else {
      discoveryCtx.updateLoading(true);
    }

    setTimeout(() => {
      api.get(
        `${webSocketBaseURL}/discovery/${user?.user_role?.user_id}/${transactionId}`
      ).then((response) => {
        const { totalCount, completedTaskCount, transactionStatus, task = [] } = response?.data;
        discoveryCtx.updateStatus({ totalCount, completedTaskCount });
        if (completedTaskCount === totalCount) {
          discoveryCtx.updateLoading(false);
        }
        else if (transactionStatus === "RUNNING") {
          startPolling(transactionId, discoveryCtx.type);
        }
        for (const record of task) {
          handleSocketData(record, transactionRecord);
        }
      })
      console.log("discoveryCtx in history", discoveryCtx);
    }, 1000);

  }
  function capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  const type = discoveryCtx.type ?? "brand";
  const llmName =
    LLM_OPTIONS.find((option) => option.value === item?.llm[0])?.name || "GPT-4o-Chat-Offline";

  return (
    <div
      className={classes.container}
      style={{
        borderLeft: `4px solid ${statusColors[item.status] || statusColors.DEFAULT}`,
      }}
    >
      <Modal
        handleClose={() => setShowDeleteDialog(false)}
        handleConfirm={deleteHistoryItemHandler}
        open={showDeleteDialog}
        title="Delete History?"
        showActions
        confirmBtnText="Delete"
        confirmBtnColor="error"
      >
        Do you want to delete this item - {name}?
      </Modal>
      <div className={classes.text_container}>
        <TextsmsOutlinedIcon />
        {!isEditing && (
          <div>
            <span title={item.name} className={classes.text}>
              {`${item.brand} ${capitalize(type)} Overview`}
            </span>
            <div className={classes.meta}>
              <span className={classes.sub_text} title={item?.category[0]}>
                {item?.category[0]}
              </span>
              <span>&middot;</span>
              {item?.market && (
                <>
                  <span className={classes.sub_text} title={item?.market}>
                    {item?.market == "GeneralMarket" ? "General Market" : item?.market}
                  </span>
                  <span>&middot;</span>
                </>
              )}
              <span className={classes.sub_text} title={llmName}>
                {llmName}
              </span>
            </div>
          </div>
        )}
        {isEditing && (
          <Input
            disableUnderline
            className={classes.input}
            style={{ borderColor: isError ? "red" : "gray" }}
            type="text"
            value={name}
            onKeyDown={handleKeyDown}
            onChange={handleInputChange}
          />
        )}
      </div>
      <div className={classes.action}>
        {!isEditing && (
          <>
            <MUIIconButton
              sx={{ color: "#000" }}
              onClick={() => getTransactionData(item)}
            >
              <VisibilityOutlinedIcon />
            </MUIIconButton>
            <MUIIconButton
              sx={{ color: "#000" }}
              onClick={() => setShowDeleteDialog(true)}
            >
              <DeleteOutlineOutlinedIcon />
            </MUIIconButton>
          </>
        )}
        {isEditing && (
          <MUIIconButton onClick={handleDoneEditing}>
            <DoneOutlinedIcon />
          </MUIIconButton>
        )}
      </div>
    </div>
  );
}
